/*/
 * Form Mask
 *
 * Important: apply max-lenght on inputs
 * Examples on end of file
 *
/*/
	import VMasker from 'vanilla-masker';

	const formMaskMoney = document.querySelectorAll('[data-mask="money"]')
	const formMaskPhone = document.querySelectorAll('[data-mask="phone"]')
	const formMaskCPF = document.querySelectorAll('[data-mask="cpf"]')
	const formMaskDate = document.querySelectorAll('[data-mask="date"]')

	if (formMaskMoney) { formMaskMoney.forEach(e => { VMasker(e).maskMoney() }) }
	if (formMaskPhone) { formMaskPhone.forEach(e => { VMasker(e).maskPattern('(99) 99999-9999') }) }
	if (formMaskCPF) { formMaskCPF.forEach(e => { VMasker(e).maskPattern('999.999.999-99') }) }
	if (formMaskDate) { formMaskDate.forEach(e => { VMasker(e).maskPattern('99/99/9999') }) }

	function inputPhoneHandler(masks, max, event) {
		var c = event.target
		var v = c.value.replace(/\D/g, '')
		var m = c.value.length > max ? 1 : 0
		VMasker(c).unMask()
		VMasker(c).maskPattern(masks[m])
		c.value = VMasker.toPattern(v, masks[m])
	}

	const formMasksPhone = ['(99) 9999-9999', '(99) 99999-9999']

	if (formMaskPhone) {
		formMaskPhone.forEach(e => {
			VMasker(e).maskPattern(formMasksPhone[0])
			e.addEventListener('input', inputPhoneHandler.bind(undefined, formMasksPhone, 14), false)
		})
	}

/*
 * HTML ATTRIBIUTES EXAMPLES
 *
 * DATE   ::  pattern="(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}" inputmode="numeric" data-mask="date" maxlength="10"
 * CPF    ::  pattern="\d{3}\.\d{3}\.\d{3}-\d{2}" inputmode="numeric" data-mask="cpf" maxlength="14"
 * PHONE  ::  pattern="\([0-9]{2}\)[\s][0-9]{4,5}-[0-9]{4}" data-mask="phone" maxlength="15"
*/
